"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Warning["default"];
  }
});
var _Warning = _interopRequireDefault(require("./Warning"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }